<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-form :inline="true">
            <el-form-item>
              <el-input size="mini" placeholder="客户名称/项目名称/发票号" v-model="keyword" clearable style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                size="mini"
                v-model="start_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker> -
              <el-date-picker
                size="mini"
                v-model="end_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
                <el-option
                  v-for="item in business_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="check_status" placeholder="审核状态">
                <el-option
                  v-for="item in [{'name':'全部','value':''},{'name':'未审','value':'0'},{'name':'已审','value':'1'}]"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadInvoiceTemplate(search_params)">导出模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload :action="upload_url" :on-success="uploadComplete" :file-list="upload_file_list">
                <el-button size="mini">导入开票</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadInvoiceData(search_params)">导出数据</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="onlineInvoice">在线开票</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="party_a" label="客户名称" align="center" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" width="200"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
            <el-table-column prop="invoice_amount" label="应收金额" align="center"></el-table-column>
            <el-table-column prop="invoiced_amount" label="已开票金额" align="center"></el-table-column>
            <el-table-column prop="not_invoice_amount" label="待开票金额" align="center"></el-table-column>
            <el-table-column prop="status" label="变动是否审核" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.check_status > 0 ?'success':'danger'">{{scope.row.check_status > 0 ?'已审':'未审'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作 " align="center" width="320">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-edit" v-if="ERP.isPermission(26005002002002)" @click="invoice(scope.row)">开发票</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="开发票" :visible.sync="dialogVisible" :close-on-click-modal="false">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" :rules="rules" label-width="100px" size="mini" style="margin-right: 50px;">

<!--          <el-form-item label="发票名称" prop="title">-->
<!--            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="发票类型" prop="invoice_type">
            <el-select v-model="form.invoice_type" placeholder="发票类型" clearable>
              <el-option
                v-for="item in [
                  {'name':'专用发票'},
                  {'name':'普通发票'},
                  {'name':'电子普票'},
                  {'name':'电子专票'}
                  ]"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票票号" prop="ticket_no">
            <el-input class="form-input" v-model="form.ticket_no" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="各项金额" prop="title">
            <el-table :data="multipleSelection">
              <el-table-column prop="party_a" label="客户名称" align="center" width="120"></el-table-column>
              <el-table-column prop="project_name" label="项目名称" align="center" width="120"></el-table-column>
              <el-table-column prop="entry_type_name" label="业务类型" align="center"></el-table-column>
<!--              <el-table-column prop="name" label="费项名称" align="center" width="120"></el-table-column>-->
              <el-table-column prop="month" label="应收月份" align="center"></el-table-column>
              <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
              <el-table-column prop="not_invoice_amount" label="未开票金额" align="center"></el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="开票金额" prop="title">
            <el-input class="form-input" v-model="form.amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="发票时间" prop="invoice_time">
            <el-date-picker
              v-model="form.invoice_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="附件" prop="title">
            <upload-files-sysc :host-url="host_url" :upload-url="host_url+'/contract/project/uploadFile'"  :limit="20" v-model="form.files"></upload-files-sysc>
          </el-form-item>

          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 开票列表弹框 -->
    <el-dialog title="开票列表" :visible.sync="invoiceListVisible" width="80%">
        <el-button type="primary" @click="invoiceForm">开票登记</el-button>
        <el-table :data="invoiceList">
          <el-table-column prop="invoice_type" label="类型"></el-table-column>
          <el-table-column prop="ticket_no" label="发票号"></el-table-column>
          <el-table-column prop="amount" label="开票金额"></el-table-column>
          <el-table-column prop="invoice_time" label="开票日期"></el-table-column>
          <el-table-column label="是否审核">
            <template #default="scope">
              <span v-if="scope.row.check_status > 0">已审核</span>
              <span v-else>未审核</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="380px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="ERP.isPermission(26005002002002)" :disabled="scope.row.check_status > 0" @click="updateInvoice(scope.row)">修改</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002002001)" :disabled="scope.row.check_status > 0" @click="checkInvoice(scope.row)">审核</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002002001)" :disabled="scope.row.check_status < 1" @click="checkInvoice(scope.row)">反审核</el-button>
              <el-button size="mini" type="danger" v-if="ERP.isPermission(26005002002003)" :disabled="scope.row.check_status > 0" @click="delInvoice(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>

    <!-- 在线开票弹框 -->
    <el-dialog title="在线开票" :visible.sync="onlineInvoiceVisible" width="70%" :close-on-click-modal="false">
      <div style="max-height: 600px;overflow-y: auto;">
        <el-form :model="onlineInvoiceForm" ref="onlineInvoiceForm" :rules="onlineInvoiceRules" label-width="140px" size="mini" style="margin-right: 50px;">
          <el-form-item label="发票类型" prop="invoice_type">
            <el-select v-model="onlineInvoiceForm.invoice_type" placeholder="请选择发票类型" clearable style="width: 100%;">
              <el-option
                v-for="item in [
                  {'name':'电子普票', 'value': '电子普票'},
                  {'name':'电子专票', 'value': '电子专票'}
                  ]"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票抬头" prop="title">
            <el-input class="form-input" v-model="onlineInvoiceForm.title" placeholder="请输入发票抬头" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号">
            <el-input class="form-input" v-model="onlineInvoiceForm.taxNo" placeholder="请输入纳税人识别号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="是否不动产发票">
            <el-select v-model="onlineInvoiceForm.taxAddressType" @change="handleTaxAddressChange" style="width: 100%;">
              <el-option label="否" :value="0"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="onlineInvoiceForm.taxAddressType === 1" label="不动产所在省市">
            <el-input class="form-input" v-model="onlineInvoiceForm.realEstatePlace" placeholder="请填写所在省市区"></el-input>
          </el-form-item>
          <el-form-item v-if="onlineInvoiceForm.taxAddressType === 1" label="不动产详细地址（不含省市）">
            <el-input class="form-input" v-model="onlineInvoiceForm.fullAddress" placeholder="请填写详细地址"></el-input>
          </el-form-item>
          <el-form-item label="购方地址">
            <el-input class="form-input" v-model="onlineInvoiceForm.address" placeholder="请输入购方地址" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开户行">
            <el-input class="form-input" v-model="onlineInvoiceForm.bank" placeholder="请输入开户行" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="银行账号">
            <el-input class="form-input" v-model="onlineInvoiceForm.bankAccount" placeholder="请输入银行账号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input class="form-input" v-model="onlineInvoiceForm.phone" placeholder="请输入电话" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input class="form-input" v-model="onlineInvoiceForm.email" placeholder="请输入邮箱" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开票税盘">
            <el-select v-model="onlineInvoiceForm.disc_id" placeholder="请选择开票税盘" clearable style="width: 100%;" @change="handleDiscChange">
              <el-option
                v-for="item in discList"
                :key="item.id"
                :label="'税号：' + item.tax_number + ' 开票人：' + item.drawer + ' 备注：' + item.remark"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单明细">
            <el-table :data="onlineInvoiceOrderList" border>
              <el-table-column prop="party_a" label="客户名称" align="center" width="120"></el-table-column>
              <el-table-column prop="project_name" label="项目名称" align="center" width="150"></el-table-column>
              <el-table-column prop="entry_type_name" label="业务类型" align="center" width="100"></el-table-column>
              <el-table-column prop="month" label="应收月份" align="center" width="100"></el-table-column>
              <el-table-column prop="not_invoice_amount" label="未开票金额" align="center" width="120"></el-table-column>
              <el-table-column label="开票金额" align="center" width="120">
                <template slot-scope="scope">
                  <el-input
                    size="mini"
                    v-model="scope.row.invoice_money"
                    @blur="handleOnlineInvoiceMoneyChange(scope)"
                    type="number"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="开票税目" align="center" width="120">
                <template slot-scope="scope">
                  {{ scope.row.tax_code }}
                </template>
              </el-table-column>
              <el-table-column label="服务名称" align="center" width="150">
                <template slot-scope="scope">
                  {{ scope.row.tax_name }}
                </template>
              </el-table-column>
              <el-table-column label="税率(%)" align="center" width="100">
                <template slot-scope="scope">
                  {{ scope.row.tax_rate }}
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 10px; font-weight: bold;">
              开票总金额：{{ onlineInvoiceTotal.toFixed(2) }}
            </div>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              type="textarea"
              placeholder="请输入备注内容"
              v-model="onlineInvoiceForm.remarks"
              maxlength="200"
              show-word-limit
              :rows="3"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="onlineInvoiceVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOnlineInvoice('onlineInvoiceForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import Api from "./common/Api";
import {Message} from "element-ui";

export default {
  name:"ContractFinanceInvoice",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      upload_url : '',
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      rules: {
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'change' },
        ],
        ticket_no: [
          { required: true, message: '请填输入发票', trigger: 'blur' },
        ],
        invoice_time: [
          { required: true, message: '请选择发票时间', trigger: 'change' },
        ],
        is_void: [
          { required: true, message: '请选择款项类型', trigger: 'change' },
        ],
      },
      form:{
        name:"",
        invoice_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        invoice_time:"",
        files:"",
        status:true,
        remarks:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      month_value:"",
      start_month : '',
      end_month : '',
      multipleSelection:[],
      check_status : '',
      f_status:"2,3",
      business_list:[],
      entry_type_name:"",
      // 开票列表
      invoiceRow : {},
      invoiceList : [],
      invoiceListVisible : false,
      upload_file_list : [],
      // 在线开票
      onlineInvoiceVisible : false,
      onlineInvoiceForm : {
        invoice_type : "",
        title : "",
        taxNo : "",
        taxAddressType : 0,
        realEstatePlace : "",
        fullAddress : "",
        address : "",
        bank : "",
        bankAccount : "",
        phone : "",
        email : "",
        disc_id : "",
        remarks : "",
      },
      onlineInvoiceOrderList : [],
      discList : [],  // 税盘列表
      onlineInvoiceRules : {
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'change' },
        ],
        title: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.upload_url = Api.getUploadUrl('/contract/FinanceInvoice/batchInvoice')
    this.start_month = CommonHelp.date("YYYY-MM");
    this.end_month = CommonHelp.date("YYYY-MM");
    // this.month_value=CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        this.multipleSelection = []
      }
    },
    "form.province_city_ids":function (n) {
      n&&n[0]&&(this.form.province_id=n[0])
      n&&n[1]&&(this.form.city_id=n[1])
      console.log(n)
    },
    "form.contract_area_ids":function (n) {
      console.log(n)
    },
    invoice_account(n){
      console.log(n);
    },
    finance_ids(n){
      console.log(n)
    }

  },
  computed:{
    Api() {
      return Api
    },
    invoice_account(){
      return this.multipleSelection.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.invoice_amount*1);
        return total;
      }, 0)
    },
    finance_ids(){
      return this.multipleSelection.map(ret=>{return ret.id;})
    },
    search_params(){
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      // this.month_value&&(where.month=this.month_value);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      where.start_month = this.start_month;
      where.end_month = this.end_month;
      where.check_status = this.check_status;
      return where;
    },
    // 在线开票总金额
    onlineInvoiceTotal() {
      return this.onlineInvoiceOrderList.reduce((total, item) => {
        return total + (parseFloat(item.invoice_money) || 0);
      }, 0);
    },
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        invoice_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        invoice_time:"",
        files:"",
        status:true,
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      CommonHelp.get("FinanceInvoice/getList",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            ret.invoice_amount=ret.invoice_amount>0?ret.invoice_amount:ret.amount;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    invoice(item) {
      this.invoiceRow = item;
      this.invoiceListVisible = true;
      this.getInvoiceList(item.id);
    },
    invoiceForm(){
      let item=CommonHelp.reObject(this.invoiceRow)
      this.multipleSelection=[item];
      this.invoices(item);
    },
    invoices(){
      this.form = this.getFormData({})
      this.form.amount=this.invoice_account;
      this.form.finance_id=this.finance_ids[0];
      this.dialogVisible = true
    },
    getInvoiceList(id){
      let that = this;
      Api.invoiceList({id : id} , 0 , 0 ,(res) => {
        that.invoiceList = res.list;
      })
    },
    checkInvoice(row){
      var that=this;
      that.$confirm('是否确定操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CommonHelp.post("FinanceInvoice/check_status_change",{ids:row.id},res=>{
          if(res.code) {
            that.getInvoiceList(row.finance_id);
          }else {
            that.$message({
              type: 'warning',
              message: res.msg||"请求异常"
            });
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          CommonHelp.post("FinanceInvoice/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.multipleSelection=[];
              that.getList()
              this.getInvoiceList(data.finance_id)
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      CommonHelp.post("FinanceInvoice/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.multipleSelection=[];
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Finance/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Finance/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    selectable(row,index){
      let is_invoice=row.is_invoice;
      let status=row.status === 2;
      let is_end=!row.is_end;
      console.log(is_invoice&&status&&is_end , is_invoice , status , is_end)
      return is_invoice&&status&&is_end;
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    date(time){
      return CommonHelp.date("YYYY-MM-DD",time)
    },
    // 修改开票
    updateInvoice(row){
      this.form = this.getFormData(row);
      let item = CommonHelp.reObject(this.invoiceRow);
      this.multipleSelection=[item];
      this.form.ticket_no=row.ticket_no;
      this.form.name=row.name;
      this.form.invoice_type=row.invoice_type;
      this.form.amount=row.amount;
      this.form.finance_id=row.finance_id;
      this.form.id = row.id;
      this.form.status = 1;
      this.dialogVisible = true
    },
    // 删除开票
    delInvoice(id) {
      let that = this;
      this.$confirm('确认删除吗？', '提示' , {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api.invoiceDel(id , res => {
          that.invoiceListVisible = false;
          that.dialogVisible = false;
          that.getList();
        })
      })
    },
    uploadComplete(res){
      if(res.code){
        Message.success(res.msg)
        this.upload_file_list = [];
        this.getList();
      }else{
        Message.error(res.msg);
      }
    },
    // 在线开票
    onlineInvoice() {
      // 校验是否至少勾选一行
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少勾选一行开票数据'
        });
        return;
      }

      // 校验多行时客户名称是否一致
      if (this.multipleSelection.length > 1) {
        const firstCustomerName = this.multipleSelection[0].party_a;
        const allSameCustomer = this.multipleSelection.every(item => item.party_a === firstCustomerName);

        if (!allSameCustomer) {
          this.$message({
            type: 'warning',
            message: '客户名称必须一致'
          });
          return;
        }
      }

      // 初始化表单数据
      this.onlineInvoiceForm = {
        invoice_type : "",
        title : this.multipleSelection[0].party_a || "",
        taxNo : "",
        taxAddressType : 0,
        realEstatePlace : "",
        fullAddress : "",
        address : "",
        bank : "",
        bankAccount : "",
        phone : "",
        email : "",
        disc_id : "",
        remarks : "",
      };

      // 重置税盘列表
      this.discList = [];

      // 初始化订单列表，默认开票金额为未开票金额
      this.onlineInvoiceOrderList = this.multipleSelection.map(item => ({
        ...item,
        invoice_money: item.not_invoice_amount || 0,
        tax_code: '',
        tax_name: '',
        tax_rate: ''
      }));

      // 获取合同税盘信息
      this.getContractTaxInfo();

      this.onlineInvoiceVisible = true;
    },
    // 获取合同税盘信息
    getContractTaxInfo() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        return;
      }

      // 提取所有合同ID，以逗号隔开
      const contractIds = this.multipleSelection.map(item => item.contract_id).join(',');

      CommonHelp.post("InvoiceDisc/getContractTax", { id: contractIds }, res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          // 创建合同ID到税盘信息的映射
          const taxMap = {};
          res.data.forEach(tax => {
            taxMap[tax.contract_id] = tax;
          });

          let area_id = [];

          // 将税盘信息匹配到订单列表
          this.onlineInvoiceOrderList.forEach(order => {
            const taxInfo = taxMap[order.contract_id];
            if (taxInfo) {
              this.$set(order, 'tax_code', taxInfo.tax_code || '');
              this.$set(order, 'tax_name', taxInfo.tax_name || '');
              this.$set(order, 'tax_rate', taxInfo.tax_rate || '');

              if(taxInfo.contract_area_ids){
                taxInfo.contract_area_ids.forEach(areaId => {
                  if(!area_id.includes(areaId)){
                    area_id.push(areaId);
                  }
                })
              }
            }
          });

          // 获取税盘列表
          if (area_id.length > 0) {
            this.getDiscList(area_id);
          }
        }
      });
    },
    // 获取税盘列表
    getDiscList(areaIds) {
      CommonHelp.get("InvoiceDisc/getInvoiceDiscList", {
        area_id: areaIds.join(',')
      }, res => {
        if (res.code === 200 && res.data) {
          this.discList = res.data.list || res.data || [];

          // 如果只有一个税盘，自动选中
          if (this.discList.length === 1) {
            this.onlineInvoiceForm.disc_id = this.discList[0].id;
          }
        }
      });
    },
    // 处理税盘变化
    handleDiscChange(value) {
      console.log('选中的税盘ID:', value);
    },
    // 处理在线开票金额变化
    handleOnlineInvoiceMoneyChange(scope) {
      // 校验开票金额不能大于未开票金额
      if (parseFloat(scope.row.invoice_money) > parseFloat(scope.row.not_invoice_amount)) {
        this.$message.error('开票金额不能大于未开票金额');
        this.$set(scope.row, 'invoice_money', scope.row.not_invoice_amount);
        return;
      }

      // 确保属性变更可被检测
      this.$set(scope.row, 'invoice_money', scope.row.invoice_money);
    },
    // 处理不动产地址变化
    handleTaxAddressChange() {
      // 如果选择了是不动产发票，可以在这里添加获取默认地址的逻辑
      if (this.onlineInvoiceForm.taxAddressType === 1) {
        // TODO: 可以根据需要调用接口获取默认的不动产地址
      }
    },
    // 提交在线开票
    submitOnlineInvoice(formName) {
      var that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // 校验订单明细中开票金额
          if (!that.onlineInvoiceOrderList || that.onlineInvoiceOrderList.length === 0) {
            that.$message({
              type: 'warning',
              message: '请添加订单明细'
            });
            return;
          }

          // 校验每个订单的开票金额
          for (let i = 0; i < that.onlineInvoiceOrderList.length; i++) {
            const item = that.onlineInvoiceOrderList[i];
            if (!item.invoice_money || parseFloat(item.invoice_money) <= 0) {
              that.$message({
                type: 'warning',
                message: `第${i + 1}行订单的开票金额必须大于0`
              });
              return;
            }
          }

          // 准备提交数据
          const submitData = {
            title: that.onlineInvoiceForm.title,
            taxNo: that.onlineInvoiceForm.taxNo,
            address: that.onlineInvoiceForm.address,
            bank: that.onlineInvoiceForm.bank,
            bankAccount: that.onlineInvoiceForm.bankAccount,
            phone: that.onlineInvoiceForm.phone,
            email: that.onlineInvoiceForm.email,
            invoice_type: that.onlineInvoiceForm.invoice_type,
            disc_id: that.onlineInvoiceForm.disc_id,
            remarks: that.onlineInvoiceForm.remarks,
            realEstatePlace: that.onlineInvoiceForm.realEstatePlace || '',
            fullAddress: that.onlineInvoiceForm.fullAddress || '',
            pid: that.multipleSelection[0].pindex_id || that.multipleSelection[0].pid || '',
            orderList: that.onlineInvoiceOrderList.map(item => ({
              id: item.id,
              contract_id: item.contract_id,
              party_a: item.party_a,
              project_name: item.project_name,
              entry_type_name: item.entry_type_name,
              month: item.month,
              not_invoice_amount: item.not_invoice_amount,
              invoice_money: item.invoice_money,
              tax_code: item.tax_code,
              tax_name: item.tax_name,
              tax_rate: item.tax_rate,
            }))
          };

          // 显示加载提示
          const loading = that.$loading({
            lock: true,
            text: '正在开票中，请稍候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          // 调用后端接口
          CommonHelp.post("Invoice/invoice", submitData, res => {
            loading.close();
            
            if (res.code === 200) {
              that.$message({
                type: 'success',
                message: res.msg || '开票成功'
              });
              
              // 关闭弹框
              that.onlineInvoiceVisible = false;
              
              // 刷新列表
              that.getList();
              
              // 清空选择
              that.multipleSelection = [];
            } else {
              that.$message({
                type: 'error',
                message: res.msg || '开票失败'
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinanceInvoice.vue